var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteCard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 6,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.44901 3.09467L6 5.54428L3.55099 3.09467C3.4248 2.96844 3.22084 2.96844 3.09464 3.09467C2.96845 3.22089 2.96845 3.4249 3.09464 3.55113L5.54365 6.00073L3.09464 8.44887C2.96845 8.5751 2.96845 8.77911 3.09464 8.90533C3.22084 9.03156 3.4248 9.03156 3.55099 8.90533L6 6.45572L8.44901 8.90533C8.5752 9.03156 8.77916 9.03156 8.90536 8.90533C9.03155 8.77911 9.03155 8.5751 8.90536 8.44887L6.45635 6.00073L8.90536 3.55113C9.03155 3.4249 9.03155 3.22089 8.90536 3.09467C8.77916 2.96844 8.5752 2.96844 8.44901 3.09467Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteCard);
export default __webpack_public_path__ + "static/media/deleteCard.97a6e33aedf6df13881ed76efe881110.svg";
export { ForwardRef as ReactComponent };